import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Varlet from "@varlet/ui";
import "@varlet/ui/es/style.js";
// 引入全局css
import "./assets/app.css";
import "animate.css";
import { Toast } from "vant";
import "vant/lib/index.css";
import {
  Form,
  Field,
  CellGroup,
  Button,
  Dialog,
  Tag,
  Icon,
  Col,
  Row,
} from "vant";

createApp(App)
  .use(Varlet)
  .use(Toast)
  .use(Form)
  .use(Icon)
  .use(Field)
  .use(Button)
  .use(CellGroup)
  .use(Col)
  .use(Row)
  .use(Dialog)
  .use(Tag)
  .use(router)
  .mount("#app");
